<template>
	<div class="searchpages">
		<cube-page :title="'查询'">
			<div slot="content">
				<div style="position: fixed;left: 0;right: 0;z-index: 1;">
					<van-search v-model="re_value" shape="round" placeholder="请输入搜索关键词" :autofocus="true"
						@search="onSearch">
					</van-search>
				</div>
				<div style="z-index: 30;">
					<van-swipe class="swipebox" :autoplay="3000" lazy-render height="225">
						<van-swipe-item v-for="(item,index) in banner" :key="item.id">
							<a :href="item.url"><img :src="item.image" /> </a>
						</van-swipe-item>
					</van-swipe>
					<div style=" margin-top: 15px; display: flex;flex-direction: row;width: 100%;">
						<div style="background-color: #f8f8f8;width: 6em; overflow: scroll;">
							<van-sidebar v-model="active" @change="onChange">
								<van-sidebar-item v-for="(rd, index) in recommendData" :key="rd.id" :title="rd.name" />
							</van-sidebar>
						</div>
						<div style="width: 100%;height: 600px; overflow: scroll;" v-if="showdata" class="listdata">
							<van-empty v-if="isNoData" description="还没有相关的商品">
								<template #image>
									<img src="@/assets/img/empty.png" alt="">
								</template>
							</van-empty>
							<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了"
								:immediate-check="false" @load="onLoad">
								<div class="items">
									<div class="item" v-for="(rd, index) in listData" :key="index"
										@click="togoods(rd.goods_id)">
										<van-image fit="cover" class="img" :src="rd.image">
										</van-image>
										<div class="textconten">
											<div class="ells ttname">
												{{rd.goods_name}}
											</div>
											<div class="tips">
											</div>
										<!-- 	<div class="pitem" v-if="isSj"> 
											{{isSj}}
												<div class="yj">
													<span class="jg">{{rd.goods_price}}</span>
													<span>{{rd.status_cn}}</span>
												</div>
												<div class="xj">
													<span class="an">
														<van-icon name="plus" />
													</span>
												</div>
											</div> -->
											<div class="pitem">
												<div class="price">
													<span style="font-size: 11px;">￥
														<span class="pricenum">{{rd.min_price}}</span>
													</span>起
												</div>
												<van-icon name="weapp-nav" />
											</div>
										</div>
									</div>
								</div>
							</van-list>
						</div>
					</div>
					<cube-view></cube-view>
				</div>
			</div>
		</cube-page>
	</div>
</template>
<script>
	import CubeView from '@/components/TP/cube-view'
	import BottomTabbar from '@/components/TP/BottomTabbar'
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import getCurrentCityName from '@/utils/getUserLocation'

	export default {
		components: {
			CubeView,
			CubePage,
			BottomTabbar
		},
		data() {
			return {
				LocationCity: "获取", //给渲染层定义一个初始值
				isCityLoading: false,
				active: this.$route.query.active ? this.$route.query.active : 0,
				recommendData: [],
				banner: [],
				loading: false,
				finished: false,
				isNoData: false,
				pageIndex: 1,
				pageTotal: 0,
				listData: [],
				showdata: false,
				re_value: '',
				gcfg: [],
				store: null,
				// isSj: this.$route.query.isSj,
				storeId: this.$route.query.store_id,
			};
		},
		created() {  
			//this.getCity()
			this.axios_Request();
		},
		methods: {
			togoods(id) {
				localStorage.setItem("goodsId", id)
				//leo
				util.redirect('goodsdetail?id=' + id + '&isSj=false');
			
			},
			//获取城市
			getCity() {
				let that = this
				that.isCityLoading = true
				getCurrentCityName().then((city) => {
					that.isCityLoading = false
					that.LocationCity = city
				})
			},
			onSearch() {
				//跳转
				let that = this
				util.redirect('leoreList?name=' + that.re_value + '&isSj=false');
				// ./leoreList?cid='+rd.id+'&name='+rd.name+'&isSj='+isSj
				// this.$router.push({
				// 	path: './leoreList',
				// 	query: {
				// 		name: that.re_value,
				// 		isSj: false
				// 	}
				// })
			},
			onChange(key) {
				this.loading = false;
				this.finished = false;
				this.isNoData = false;
				this.listData = []
				this.pageIndex = 1
				this.pageTotal = 0
				this.getDataList()
			},
			axios_Request() {
				let that = this;
				var url = "/addons/litestore/api.category/Showlist"
				let id = that.storeId ? that.storeId : this.$store.getters.getShop 
				let parms = {
					store_id: id,
					isSj: false
				}
				console.log(parms)
				//util.isToken
				//这里直接调用网络接口
				util.get(url, parms,
					function(result) {
						that.banner = result['data']['banner']
						that.recommendData = result['data']['categorydata']
						that.getDataList();
						that.showdata = true
					},
				);
			},
			// 上滑加载更多
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.getDataList();
				}, 1000)
			},
			getDataList() {
				var url = "/addons/litestore/api.shop/getCategoryGoods"
				let that = this;
				let id = that.storeId ? that.storeId : this.$store.getters.getShop
				that.isNoData = false
				//这里直接调用网络接口
				util.get(url, {
						store_id: id,
						category_id: that.recommendData[that.active].id,
						page: that.pageIndex,
						isSj: false
					},
					function(result) {
						let data = result.data
						that.loading = false;
						//这里对状态 进行分类
						that.pageTotal = data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (data.list == null || data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.listData = that.listData.concat(data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.listData.length >= that.pageTotal) {
							that.finished = true;
						}
						// that.listData = result['data']['list']
						that.showdata = true
					},
				);
			},
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			// "$store.state.shop"() {
			// 	this.store = this.$store.getters.getShop
			// }
		}
	}
</script>

<style scoped="scoped" lang="less">
	@import url("../../assets/css/base.less");
	@import url("../../assets/css/listboxless.less");

	// .van-search__content {
	// 	background-color: #FFFFFF;
	// 	box-shadow: 0 5px 25px #3f3f3f;
	// }

	.cube-page {
		background-color: #fff !important;
	}

	.van-badge--select {
		border-color: #6d189e;
	}

	.van-info {
		background-color: #6d189e;
	}

	.van-card__desc {
		max-height: 34px;
		white-space: inherit;
	}

	.van-card__thumb {
		top: 10px;
	}

	.listdata {
		.items {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			padding: 5px 10px 30px 10px;

			.item {
				margin-top: 10px;
				min-width: 0;
				width: 48%;
				// border-radius: 10px;
				padding-bottom: 10px;
				box-shadow: 0 0 5px #ececec;
				// background-color: #f5f5f5;

				.img {
					height: 140px;
					width: 100%;

					.van-image__error {
						background: rgba(213, 213, 213, 0.5);
						border-top-left-radius: 10px;
						border-top-right-radius: 10px;
					}

					img {
						border-top-left-radius: 10px;
						border-top-right-radius: 10px;
					}

					.ttip {
						background: rgba(8, 8, 8, 0.2);
						color: #fff;
					}
				}

				.textconten {
					padding: 0 8px;
				}

				.ttname {
					font-size: 14px;
					line-height: 20px;
					font-weight: 600;

					.tip {
						background-color: #ff0000;
						padding: 2px 5px;
						font-size: 12px;
						color: #fff;
						border-radius: 5px;
						font-weight: 400;
					}
				}

				.tips {
					margin: 4px 0;

					span {
						padding: 2px 5px;
						font-size: 12px;
						background-color: #ffe7c0;
						color: #ff7e3e;
						border-radius: 5px;
					}
				}

				.pitem {
					padding-top: 5px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					color: #737373;

					.price {
						font-size: 14px;

						span {
							color: #ff0000;

							.pricenum {
								font-size: 16px;
							}
						}
					}

					.yj {
						color: #ff0000;
						font-size: 13px;

						span {
							padding-right: 5px;

						}

						.jg {
							font-size: 18px;
							padding-top: 3px;
						}
					}

					.xj {
						color: #ff0000;
						font-size: 13px;

						span {
							font-size: 12px;
							font-weight: 600;
						}

						.an {
							text-align: center;
							border: 1px solid #ff0000;
						}
					}
				}
			}
		}
	}
</style>
